import { Fragment as _Fragment, jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useAuth } from "../auth/AuthContext";
import { useAuthQuery } from "../auth/queries/auth.graphql.generated";
import { WebsocketConnection } from "./WebsocketConnection";
export const HighlightWebsocket = ({ children, }) => {
    const { authenticated } = useAuth();
    const { data, loading, error, refetch } = useAuthQuery({
        skip: !authenticated,
    });
    if (error)
        return _jsx(_Fragment, { children: children });
    if (loading || !data || !data.auth.token)
        return _jsx(_Fragment, { children: children });
    return (_jsx(_Fragment, { children: _jsx(WebsocketConnection, { onClose: refetch, token: data.auth.token, children: children }) }));
};
